import script from "./ConfirmManualncomeVerificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmManualncomeVerificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmManualncomeVerificationModal.vue?vue&type=style&index=0&id=552dbd8c&lang=css"
import "./ConfirmManualncomeVerificationModal.vue?vue&type=style&index=1&id=552dbd8c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552dbd8c"]])

export default __exports__